(function () {
  var marker = 'ZOALIN_PC_COLLECTION_DESC_HIDE_LIGHT_20260728_0258';

  function isPcCollection() {
    return document.body &&
      document.body.classList.contains('template-collection') &&
      window.matchMedia &&
      window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  function run() {
    if (!isPcCollection()) return;

    document.querySelectorAll("[class*='__text_twGGkJ']").forEach(function (node) {
      node.style.setProperty('display', 'none', 'important');
      node.style.setProperty('height', '0', 'important');
      node.style.setProperty('min-height', '0', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('padding', '0', 'important');
      node.style.setProperty('overflow', 'hidden', 'important');
      node.setAttribute('data-zoalin-pc-collection-description-removed', marker);
    });

    document.documentElement.setAttribute('data-zoalin-pc-collection-desc-hide-light', marker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  window.addEventListener('load', run, { passive: true, once: true });
  [120, 450, 1200].forEach(function (delay) {
    window.setTimeout(run, delay);
  });
})();
